import type {EditingNode, EditingOp} from '@wandb/weave/core';
import * as React from 'react';

import {createPreloadableLazyComponent} from '../../../util/lazyImport';
import * as S from './PanelComp.styles';

export interface ComputeGraphVizProps {
  node: EditingNode;
  highlightNodeOrOp?: EditingNode | EditingOp;
  width: number;
  height: number;
}

const {Component: LazyComputeGraphViz} = createPreloadableLazyComponent(
  () => import('./ComputeGraphVizImpl'),
  module => module.default
);

export const ComputeGraphViz: React.FC<ComputeGraphVizProps> = props => {
  return (
    <React.Suspense fallback={<S.Panel2LoaderStyle data-test="loader" />}>
      <LazyComputeGraphViz {...props} />
    </React.Suspense>
  );
};
